import { Box, Paper, Skeleton, Stack, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { alpha } from '@mui/material/styles';
import { format } from 'date-fns';
import { Timeline, TimelineDot, TimelineItem, TimelineContent, TimelineSeparator, TimelineConnector } from '@mui/lab';
import { Label, PreviewItem } from '../../../components';
import usePageTitle from '../../../hooks/usePageTitle';
import { useParams, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { merchantApi } from '../../../redux/api/apiConfig';
import { DEPOSITS } from '../../../ApiUrl';
import { capitalize, startCase } from 'lodash';
import back from '../../../assets/img/icons/back.svg';
import bg from '../../../assets/illustrations/notFound.svg';
import Image from '../../../components/image/Image';

const DepositsHistory = () => {
  const [loading, setLoading] = useState(true);
  const [deposit, setDeposit] = useState(null);
  const { id } = useParams();
  const history = useHistory();

  const getDepositDetails = useCallback(async () => {
    try {
      setLoading(true);
      const response = await merchantApi.get(`${DEPOSITS}${id}/`);
      setDeposit(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);

      toast.error(error?.data?.data?.message || 'Something went wrong');
      // toast.error('Could not fetch deposit details');
    }
  }, [id]);

  useEffect(() => {
    getDepositDetails();
  }, [getDepositDetails]);

  usePageTitle('Deposit History', 'View deposit change history');

  const backClickHandler = () => {
    history.goBack();
  };
  console.log(loading, deposit, loading && !deposit);
  return (
    <Box sx={{ padding: '0 24px 24px', height: 'calc(100vh - 100px)' }}>
      <span onClick={backClickHandler} className='back mb-4'>
        <img src={back} alt='back' />
        <span>Back</span>
      </span>
      {!loading && !deposit?.history ? (
        <Stack sx={{ justifyContent: 'center', alignItems: 'center', gap: 2, mt: 4 }}>
          <Image src={bg} sx={{ width: { sm: '200px', md: '300px' } }} />
          <Typography variant='h6'>No Status History Found!</Typography>
        </Stack>
      ) : (
        <Timeline position='alternate'>
          {(loading ? [...Array(3)] : deposit?.history)?.map((item, i) => (
            <TimelineItem key={i}>
              <TimelineSeparator>
                <TimelineDot
                  color={(() => {
                    switch (item?.status?.value) {
                      case 'submitted':
                        return 'warning';
                      case 'query':
                        return 'error';
                      case 'confirmed':
                        return 'success';
                      case 're_evalution':
                        return 'warning';
                      default:
                        return 'error';
                    }
                  })()}
                />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ textAlign: 'left !important' }}>
                {loading ? <Skeleton variant='rounded' animation={'wave'} height={100} /> : <HistoryItem item={item} i={i} deposit={deposit} />}
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      )}
    </Box>
  );
};

const HistoryItem = ({ item, deposit, i, type }) => {
  let label;
  // const { value, status } = status?.status?;
  // console.log(item.status);
  const status = item?.status;
  const name = startCase(item?.status?.receiver_name);
  const isInitialStatus = i == deposit.history.length - 1;
  switch (status.value) {
    case 'submitted':
      console.log(status, 'Approved');
      label = (
        <Label variant={'ghost'} color={'application submitted'}>
          {name}
        </Label>
      );
      break;
    case 're_evalution':
      console.log(status, 'Approved');
      label = (
        <Label variant={'ghost'} color={'application submitted'}>
          {name}
        </Label>
      );
      break;
    case 'query':
      console.log(status, 'Requested');
      label = (
        <Label variant={'ghost'} color={'rejected'}>
          {name}
        </Label>
      );
      break;
    case 'confirmed':
      console.log(name, 'Requested');
      label = (
        <Label variant={'ghost'} color={'complete'}>
          {name}
        </Label>
      );
      break;

    default:
      console.log(name, 'default');
      label = (
        <Label variant={'ghost'} color={'rejected'}>
          {name}
        </Label>
      );
      break;
  }

  return (
    <Paper
      sx={{
        borderRadius: '8px',
        borderColor: '#000',
        bgcolor: (theme) => {
          switch (status.value) {
            case 'submitted':
              console.log(status);
              return alpha(theme.palette.warning.light, 0.1);
            case 're_evalution':
              console.log(status);
              return alpha(theme.palette.warning.light, 0.1);

            case 'query':
              console.log(status);
              return alpha(theme.palette.error.light, 0.1);
            case 'confirmed':
              console.log(status);
              return alpha(theme.palette.success.light, 0.1);
            default:
              console.log(status);
              return alpha(theme.palette.error.light, 0.1);
          }
        },
        padding: '1rem',
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        <PreviewItem title={'Status'} tooltip={false} content={label || ''} />
        <PreviewItem title={'Remarks'} content={i == deposit.history.length - 1 ? capitalize(deposit.remarks) : capitalize(item?.remarks)} />
        <PreviewItem
          title={isInitialStatus ? 'Requested By' : 'Updated By'}
          content={isInitialStatus ? capitalize(item?.created_user) : capitalize(item?.modified_user)}
        />
        <PreviewItem title={'Date'} content={format(new Date(item?.modified_date), 'dd MMM yyyy HH:mm a')} />
      </Stack>
    </Paper>
  );
};

export default DepositsHistory;
